import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { BaseComponent, TabComponent, TabGroupComponent } from '@sircon/sircon-ui-framework';
import { NgIf } from '@angular/common';
import { AccountBackupEmailComponent } from '../account-backup-email/account-backup-email.component';
import { AccountSecurityQuestionsComponent } from '../account-security-questions/account-security-questions.component';

interface Step {
    title: string;
    enabled: boolean;
}

@Component({
    selector: 'app-account-security-update',
    templateUrl: './account-security-update.component.html',
    imports: [TabGroupComponent, TabComponent, NgIf, AccountBackupEmailComponent, AccountSecurityQuestionsComponent]
})
export class AccountSecurityUpdateComponent extends BaseComponent implements OnInit {
    @Input() showSecurityQuestions: boolean;
    @Input() showBackupEmail: boolean;
    @Input() userId: string;
    @Input() primaryEmail: string;

    @Output() accountSecurityUpdateCompleteEvent: EventEmitter<void> = new EventEmitter();

    readonly SECURE_YOUR_ACCOUNT = 'Secure Your Account';
    readonly SECURITY_QUESTIONS = 'Security Questions';
    readonly BACKUP_EMAIL = 'Backup Email';

    possibleSteps: Step[];
    steps: Step[] = [];
    currentStepIndex = 0;

    accountSecurityQuestionsSubmitted = false;

    ngOnInit(): void {
        this.possibleSteps = [
            { title: this.SECURE_YOUR_ACCOUNT, enabled: true },
            { title: this.SECURITY_QUESTIONS, enabled: this.showSecurityQuestions },
            { title: this.BACKUP_EMAIL, enabled: this.showBackupEmail }];
        this.steps = this.possibleSteps.filter((step: Step): boolean => step.enabled);
        this.accountSecurityQuestionsSubmitted = !this.showSecurityQuestions;
    }

    isFirstStep(): boolean {
        return this.currentStepIndex <= 0;
    }

    isLastStep(): boolean {
        return this.currentStepIndex >= (this.steps.length - 1);
    }

    nextStepIndex(): number {
        const nextIndex: number = this.currentStepIndex + 1;
        const maximumIndex: number = this.steps.length - 1;

        return Math.min(nextIndex, maximumIndex);
    }

    securityQuestionsIndex(): number {
        return this.steps.findIndex((step: Step): boolean => step.title === this.SECURITY_QUESTIONS);
    }

    next(): void {
        if (!this.isLastStep()) {
            this.currentStepIndex = this.nextStepIndex();
            return;
        }

        if (!this.accountSecurityQuestionsSubmitted) {
            this.currentStepIndex = this.securityQuestionsIndex();
            return;
        }

        this.accountSecurityUpdateCompleteEvent.emit();
    }

    previous(): void {
        this.currentStepIndex = Math.max((this.currentStepIndex - 1), 0);
    }

    handleCloseEvent(event) {
        if (event.action === 'skip') {
            this.next();
        } else if (event.action === 'cancel') {
            this.previous();
        }
    }

    onAccountSecurityQuestionsSubmitted(): void {
        this.accountSecurityQuestionsSubmitted = true;
        this.next();
    }
}
